import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { getCookie } from '../common_component/cookie.js';
import { Drawer, Tooltip } from 'antd';
import moment from 'moment';

import { useAuthData } from "./auth-provider.js";
import StatusBadge from "../common_component/StatusBadge.js";
import PageError from '../common_component/PageError.js';
import { Pagination } from 'antd';
import { useTheme } from "./theme-provider.js";
import { useModal } from "../providers/modal-provider.js";

function ListVendor(props) {
    const [state, setstate] = useState(2);
    const { theme, dropdownStyleDark } = useTheme();
    const containerRef = useRef(null)

    const { openModal, setModalView, setModalData } = useModal()

    const [taxDetails, setTaxDetails] = useState([])
    const [vendorHistoryDetails, setVendorHistoryDetails] = useState([]);
    const [vendorAdditonalDetailsAPIState, setVendorAdditonalDetailsAPIState] = useState(false)

    const [vendorId, setVendorId] = useState("");

    const [gstinModalShow, setGstinModalShow] = useState(false);

    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [sortColumn, setSortColumn] = useState(null) //why this isn't used to sort the columns
    const [sortValue, setSortValue] = useState(null)
    const [searchValue, setSearchValue] = useState(null)
    const [vendorsList, setVendorsList] = useState([])
    const [vendorsListApiState, setVendorsListApiState] = useState(false)

    const [open, setOpen] = useState(false);
    const [navtype, setnavtype] = useState("Overview");
    const [vendorName, setVendorName] = useState("");
    const [vendorDetails, setVendorDetails] = useState([]);
    const [vendorContactPersons, setVendorContactPersons] = useState([])


    var page_name = "list-vendor";
    const apiController = useRef(new AbortController());

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const setUpDrawer = (vendorId) => {
        setOpen(true);
        setVendorId(vendorId);

        let tempData = vendorsList.find(option => option.cid == vendorId)
        setVendorName(tempData.vendor_display_name);
        setVendorDetails(tempData);
        setVendorContactPersons(JSON.parse(tempData.contact_persons));

        getVendorAdditionalDetails(vendorId);
    }

    const onClose = () => {
        setOpen(false);
        setVendorId("");
        setnavtype("Overview");

        setVendorName("");
        setVendorDetails([]);
        setVendorContactPersons([])
        setTaxDetails([]);
        setVendorHistoryDetails([]);
    };

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    async function getVendorAdditionalDetails(val) {
        setVendorAdditonalDetailsAPIState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-vendor-additional_details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "cid": val, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "danger") {
            throw "something went wrong"
        }
        else {
            setVendorHistoryDetails(body.data.vendor_history_details);
            setTaxDetails(body.data.tax_details);
            setVendorAdditonalDetailsAPIState(false)
        }
    }

    async function getVendors(cp, rpp, sort_c, sort_v, search_v) {
        try {
            if (vendorsListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setVendorsListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/vendor-datatable`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "current_page": cp - 1, "rows_per_page": rpp, "sort_column": sort_c, "sort_value": sort_v, "search_value": search_v, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation === "success") {
                setVendorsListApiState(false);
                setVendorsList(body.data.list);
                setListCount(body.data.count);
            }
            else {
                throw "vendor list api error"
            }
        } catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {

            let p1 = getVendors(currentPage, rowsPerPage, sortColumn, sortValue, searchValue)

            Promise.all([p1])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            getVendors(currentPage, rowsPerPage, sortColumn, sortValue, searchValue)
        }
    }, [currentPage, rowsPerPage, sortColumn, sortValue, searchValue])

    const changeVendorGSTStatus = (status, id) => {
        var object = {};

        object.unique_id = id
        object.status = status

        object.organization_id = organization_id;
        object.page_name = page_name;

        // console.log(object);

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-vendor-gst-status`, object, headers).then((res) => {
            if (res.data.operation === "success") {
                setGstinModalShow(false)
                swal("Great!", "Vendor GST status changed successfully!", "success")
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const makePrimaryGST = (unique_id, vendorId) => {
        var object = {};

        object.unique_id = unique_id
        object.vendor_id = vendorId

        object.organization_id = organization_id;
        object.page_name = page_name;

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/vendor-gst-make-primary`, object, headers).then((res) => {
            if (res.data.operation === "success") {
                setGstinModalShow(false)
                swal("Great!", "Vendor GST Preference updated successfully!", "success")
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const changeVendorStatus = (id, status) => {
        var object = {};

        object.vendor_id = id
        object.status = status

        object.organization_id = organization_id;
        object.page_name = page_name;

        // console.log(object);

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-vendor-status`, object, headers).then((res) => {
            if (res.data.operation === "success") {
                swal("Great!", "Vendor status changed successfully!", "success")
                getVendors(currentPage, rowsPerPage, sortColumn, sortValue, searchValue)
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    function scrollLeft() {
        if (containerRef.current) {
            containerRef.current.scrollBy({
                left: -100,
                behavior: "smooth",
            });
        }
    }

    function scrollRight() {
        if (containerRef.current) {
            containerRef.current.scrollBy({
                left: 100,
                behavior: "smooth",
            });
        }
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Vendors</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Tooltip title="SpotERP Docs" >
                            <a
                                href={`${process.env.REACT_APP_SPOTERP_DOCS}/purchase/vendor`}
                                className='btn btn-light-primary py-2 px-3'
                                target="_blank"
                            >
                                <i className="bi bi-journal-text fs-1 px-0"></i>
                            </a>
                        </Tooltip>
                        <Link to={`/add-vendor`} className="btn btn-sm btn-primary me-3 rounded btn-hover-scale">
                            <span className="d-md-none">
                                <svg width="15" height="15" viewBox="0 0 11 11" fill="none">
                                    <path d="M10.8756 6.56H6.50763V10.856H4.49163V6.56H0.123625V4.664H4.49163V0.344H6.50763V4.664H10.8756V6.56Z" fill="#fff">
                                    </path>
                                </svg>
                            </span>
                            <span className="d-none d-md-inline">Add Vendor</span>
                        </Link>
                    </div>
                </div>
                <div>
                    {
                        state == 1 ?
                            <div className="card mb-5 mb-xl-8">
                                <div className="card-body py-3">
                                    <div className='mb-5'>
                                        <input type="text" className='form-control fw-bold border border-primary' value={searchValue || ""} onChange={(e) => { setCurrentPage(1); setSearchValue(e.target.value); }} placeholder='Search...' />
                                    </div>

                                    <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                        {
                                            vendorsListApiState ? <div className="spinner-border text-primary w-75px h-75px my-auto"></div> :
                                                vendorsList.length > 0 ?
                                                    <>
                                                        <div className="mb-5 d-flex justify-content-center">
                                                            <Pagination
                                                                total={listCount}
                                                                onChange={(page, pageSize) => {
                                                                    setCurrentPage(page);
                                                                    if (pageSize !== rowsPerPage) {
                                                                        setCurrentPage(1);
                                                                    }
                                                                    setRowsPerPage(pageSize);
                                                                }}
                                                                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                showQuickJumper={true}
                                                                pageSize={rowsPerPage}
                                                                current={currentPage}
                                                                showSizeChanger={true}
                                                            />
                                                        </div>

                                                        <div className='overflow-auto w-100 flex-grow-1'>
                                                            <table className="table table-row-bordered text-nowrap h-preserve-whitespace table-row-gray-100 align-middle gs-0 gy-3" style={{ minWidth: "1000px" }}>
                                                                <thead>
                                                                    <tr className="fw-bold text-muted">
                                                                        <th className="min-w-150px">Vendor Name</th>
                                                                        <th className="min-w-150px">Company</th>
                                                                        <th className="min-w-150px">Email</th>
                                                                        <th className="min-w-150px">Work Phone</th>
                                                                        <th className="min-w-150px">Address</th>
                                                                        <th className="min-w-150px">Status</th>
                                                                        <th className="min-w-50px sticky-column" style={{ backdropFilter: 'blur(10px)' }}>Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        vendorsList.map((obj) => {
                                                                            return (
                                                                                <tr key={obj.cid}>
                                                                                    <td>
                                                                                        <span className="text-dark fw-bold mb-1 fs-6 gap-2 d-flex align-items-center">
                                                                                            <span className='flex-shrink-0'>{obj.vendor_display_name}</span>
                                                                                            <i className="fa-solid fa-eye fs-2 p-0 text-hover-primary cursor-pointer" onClick={() => { setUpDrawer(obj.cid) }}> </i>
                                                                                        </span>
                                                                                    </td>
                                                                                    <td><span className="text-dark d-block mb-1 fs-6">{obj.company_name ? obj.company_name : "NA"}</span></td>
                                                                                    <td><span className="text-dark d-block mb-1 fs-6">{obj.email ? obj.email : "NA"}</span></td>
                                                                                    <td><span className="text-dark d-block mb-1 fs-6">{obj.work_phone}</span></td>
                                                                                    <td><span className="text-dark d-block mb-1 fs-6">{(obj.state ? obj.state + ", " : "") + (obj.country ? obj.country : "")}</span></td>
                                                                                    <td><StatusBadge status={obj.add_status} entity={""} /></td>
                                                                                    <td className="sticky-column">
                                                                                        <div className="dropdown">
                                                                                            <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-bars px-0"></i></button>
                                                                                            {
                                                                                                write &&
                                                                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                                    <li className="py-1"><Link to={`/update-vendor/${obj.cid}`} className="dropdown-item">Edit Details</Link></li>
                                                                                                    <li className="py-1"><span style={{ cursor: 'pointer' }} onClick={(e) => { setUpDrawer(obj.cid) }} className="dropdown-item">View Details</span></li>
                                                                                                    <li className="py-1"><Link to={`/vendor-address-details/${obj.cid}`} className="dropdown-item">Update Address</Link></li>
                                                                                                    <li className="py-1"><span style={{ cursor: 'pointer' }} onClick={(e) => { getVendorAdditionalDetails(obj.cid); setGstinModalShow(true); setVendorId(obj.cid); }} className="dropdown-item">GSTIN Details</span></li>
                                                                                                    <li><span style={{ cursor: 'pointer' }} onClick={(e) => { changeVendorStatus(obj.cid, (obj.add_status == "Active" ? "Deactive" : "Active")); }} className={`dropdown-item ${obj.add_status == "Active" ? "text-danger" : "text-success"}`}>{obj.add_status == "Active" ? "Deactivate" : "Activate"}</span></li>
                                                                                                </ul>
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        <div className="mt-5 d-flex justify-content-center">
                                                            <Pagination
                                                                total={listCount}
                                                                onChange={(page, pageSize) => {
                                                                    setCurrentPage(page);
                                                                    if (pageSize !== rowsPerPage) {
                                                                        setCurrentPage(1);
                                                                    }
                                                                    setRowsPerPage(pageSize);
                                                                }}
                                                                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                pageSize={rowsPerPage}
                                                                current={currentPage}
                                                                showSizeChanger={true}
                                                                showQuickJumper={true}
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="text-muted fs-2 my-auto text-center">No data to be shown {/* <br /> <br />
                                                            <button className='btn fs-3 btn-light-primary' onClick={() => { setFlowModalShow(true) }}>
                                                                Need Help <i className="bi bi-question-circle fs-1"></i>
                                                            </button> */}
                                                    </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            :
                            state == 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                <PageError />
                    }
                </div>

            </div>
            <Modal show={gstinModalShow} onHide={() => { setGstinModalShow(false); setVendorId(""); }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>GSTIN Details</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setGstinModalShow(false); setVendorId(""); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: "#f4f6f9" }}>
                    <div className='container'>
                        {
                            vendorAdditonalDetailsAPIState ? <div className='text-center'><div className="spinner-border text-primary w-75px h-75px my-auto"></div></div> :
                                taxDetails.length === 0 ?
                                    <div className="overflow-auto pb-5">
                                        <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed min-w-lg-600px flex-shrink-0 p-6">
                                            <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.3" d="M19.0687 17.9688H11.0687C10.4687 17.9688 10.0687 18.3687 10.0687 18.9688V19.9688C10.0687 20.5687 10.4687 20.9688 11.0687 20.9688H19.0687C19.6687 20.9688 20.0687 20.5687 20.0687 19.9688V18.9688C20.0687 18.3687 19.6687 17.9688 19.0687 17.9688Z" fill="currentColor"></path>
                                                    <path d="M4.06875 17.9688C3.86875 17.9688 3.66874 17.8688 3.46874 17.7688C2.96874 17.4688 2.86875 16.8688 3.16875 16.3688L6.76874 10.9688L3.16875 5.56876C2.86875 5.06876 2.96874 4.46873 3.46874 4.16873C3.96874 3.86873 4.56875 3.96878 4.86875 4.46878L8.86875 10.4688C9.06875 10.7688 9.06875 11.2688 8.86875 11.5688L4.86875 17.5688C4.66875 17.7688 4.36875 17.9688 4.06875 17.9688Z" fill="currentColor"></path>
                                                </svg>
                                            </span>
                                            <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                                                <div className="mb-3 mb-md-0 fw-semibold">
                                                    <h4 className="text-gray-900 fw-bold">No GST Data Available.</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="d-flex flex-column gap-5">
                                        {
                                            taxDetails.map((obj, index) => {
                                                return (
                                                    <div key={index} className="fv-row w-100 flex-md-root">
                                                        <div className="card card-flush h-lg-100">
                                                            <div className="card-header mt-6">
                                                                <div className="card-title flex-column">
                                                                    <h3 className="fw-bolder mb-1">{obj.GstIn.toUpperCase()} <span className={`badge badge-light-${obj.flag === "Primary" ? "primary" : "warning"} ms-5 rounded`}>{obj.flag}</span><span className={`badge badge-light-${obj.add_status === "Active" ? "success" : "secondary"} ms-5 rounded`}>{obj.add_status}</span></h3>
                                                                </div>
                                                                <div className="card-toolbar">
                                                                    <div className="dropdown">
                                                                        {
                                                                            write && obj.flag !== "Primary" &&
                                                                            <>
                                                                                <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-bars px-0"></i></button>
                                                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">

                                                                                    {obj.gst_treatment !== "Consumer" && obj.gst_treatment !== "Unregistered Business" && obj.add_status !== "Deactivated" && <button className="dropdown-item" onClick={() => {
                                                                                        swal({
                                                                                            title: "Are you sure?",
                                                                                            text: "GST will be set to Primary",
                                                                                            icon: "warning",
                                                                                            buttons: true,
                                                                                            dangerMode: true,
                                                                                        })
                                                                                            .then((willDelete) => {
                                                                                                if (willDelete) {
                                                                                                    makePrimaryGST(obj.unique_id, obj.vendor_id)
                                                                                                }
                                                                                            });
                                                                                    }} >Make Primary</button>}
                                                                                    <button onClick={() => {
                                                                                        swal({
                                                                                            title: "Are you sure?",
                                                                                            text: "GST status will be set to " + (obj.add_status === "Active" ? "Deactivated" : "Active"),
                                                                                            icon: "warning",
                                                                                            buttons: true,
                                                                                            dangerMode: true,
                                                                                        })
                                                                                            .then((willDelete) => {
                                                                                                if (willDelete) {
                                                                                                    changeVendorGSTStatus(obj.add_status === "Active" ? "Deactivated" : "Active", obj.unique_id)
                                                                                                }
                                                                                            });
                                                                                    }} className="dropdown-item">Change Status</button>

                                                                                </ul>
                                                                                {/* :
                                                                                        // Edit Details is commented as said by SDIP - 04/10/23
                                                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                        <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-bars px-0"></i></button>
                                                                                        <button onClick={(e) => { handleEditModalShow(obj) }} className="dropdown-item">Edit Details</button>
                                                                                    </ul> */}
                                                                            </>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex flex-wrap">
                                                                <div className="card-body p-9">
                                                                    <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                        <div className="fs-6 fw-bold text-gray-700">{obj.legal_name}</div>
                                                                        <div className="fw-semibold text-gray-400">Business Legal Name</div>
                                                                    </div>
                                                                    <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                        <div className="fs-6 fw-bold text-gray-700">{obj.gst_treatment}</div>
                                                                        <div className="fw-semibold text-gray-400">GST Treatment</div>
                                                                    </div>
                                                                    <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                        <div className="fs-6 fw-bold text-gray-700">{obj.place_of_supply}</div>
                                                                        <div className="fw-semibold text-gray-400">Source of Supply</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className='btn btn-success'
                        onClick={() => {
                            setGstinModalShow(false)

                            setModalData({
                                entityType: "VENDOR",
                                entityId: vendorId,
                                page_name,
                            })
                            setModalView("GSTIN_MODAL")
                            openModal()

                            setVendorId("")
                        }}
                    >
                        <i className="las la-plus"></i>
                        Add New
                    </button>
                    <button className="btn btn-danger rounded" onClick={() => { setGstinModalShow(false); setVendorId(""); }}>Close</button>
                </Modal.Footer>
            </Modal>

            <Drawer title={vendorName} width={window.innerWidth > 1000 ? "50%" : window.innerWidth - 100} styles={{ bodyStyle: { padding: "1.5rem" } }} onClose={onClose} open={open} >
                <div className="card">
                    <div className="d-flex align-items-center">
                        <button className="btn btn-icon btn-active-color-primary border-0" onClick={scrollLeft}>
                            <i className="fas fa-chevron-left"></i>
                        </button>
                        <div className="d-flex w-100 overflow-auto" ref={containerRef}>
                            <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                                <li className="nav-item mx-lg-1">
                                    <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                                </li>
                                <li className="nav-item mx-lg-1" role="presentation">
                                    <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "GST" && "active"}`} onClick={(e) => { setnavtype("GST"); }}>GST Details</a>
                                </li>
                                <li className="nav-item mx-lg-1" role="presentation">
                                    <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Contact" && "active"}`} onClick={(e) => { setnavtype("Contact"); }}>Contact</a>
                                </li>
                                <li className="nav-item mx-lg-1" role="presentation">
                                    <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "History" && "active"}`} onClick={(e) => { setnavtype("History"); }}>History</a>
                                </li>
                            </ul>
                        </div>
                        <button className="btn btn-icon btn-active-color-primary border-0" onClick={scrollRight}>
                            <i className="fas fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
                <div className="card" id="kt_profile_details_view">
                    {
                        navtype === "Overview" ?
                            <>
                                {
                                    vendorDetails != undefined &&
                                    <div className="card-body p-9">
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Vendor Type</label>
                                            <div className="col-lg-8">
                                                <span className="fw-bold fs-6 text-gray-800">{vendorDetails.vendor_type}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Company Name</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">{vendorDetails.company_name}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Status
                                            </label>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                {
                                                    vendorDetails.add_status === "Active" ?
                                                        <span className="badge badge-success">{vendorDetails.add_status}</span> :
                                                        <span className="badge badge-danger">{vendorDetails.add_status}</span>
                                                }
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Mobile</label>
                                            <div className="col-lg-8">
                                                <a href="#" className="fw-semibold fs-6 text-gray-800 text-hover-primary">{vendorDetails.mobile}</a>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Work Phone</label>
                                            <div className="col-lg-8">
                                                <a href="#" className="fw-semibold fs-6 text-gray-800 text-hover-primary">{vendorDetails.work_phone}</a>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Email</label>
                                            <div className="col-lg-8">
                                                <a href="#" className="fw-semibold fs-6 text-gray-800 text-hover-primary">{vendorDetails.email}</a>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Website</label>
                                            <div className="col-lg-8">
                                                <span className="fw-semibold fs-6 text-gray-800">{vendorDetails.website}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Designation
                                            </label>
                                            <div className="col-lg-8">
                                                <span className="fw-bold fs-6 text-gray-800">{vendorDetails.designation}</span>
                                            </div>
                                        </div>


                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Lead Source</label>
                                            <div className="col-lg-8">
                                                <span className="fw-semibold fs-6 text-gray-800">{vendorDetails.lead_source}</span>
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">state</label>
                                            <div className="col-lg-8">
                                                <span className="fw-semibold fs-6 text-gray-800">{vendorDetails.state}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Country</label>
                                            <div className="col-lg-8">
                                                <span className="fw-semibold fs-6 text-gray-800">{vendorDetails.country}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-lg-4 fw-semibold text-muted">Remarks</label>
                                            <div className="col-lg-8">
                                                <span className="fw-semibold fs-6 text-gray-800">{vendorDetails.remarks}</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </>
                            :
                            navtype === "Batch_Serial" ?
                                <>
                                    <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                        <div className="card-title m-0">
                                            <h3 className="fw-bold">{vendorDetails.tracking_inventory_type === "Track Serial Number" ? <>Serial</> : <>Batch</>} Details</h3>
                                        </div>
                                    </div>
                                </>
                                :

                                navtype === "GST" ?
                                    <>
                                        {
                                            vendorAdditonalDetailsAPIState ?
                                                <div className="spinner-border text-primary"></div> :
                                                vendorDetails !== undefined && (
                                                    <div className="card-body p-9">
                                                        {taxDetails.map((obj, index) => (
                                                            <div key={index} className="my-3">
                                                                <div className="card card-flush h-lg-100" style={{ boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)" }}>
                                                                    <div className="d-flex flex-wrap">
                                                                        <div className="card-body p-3">
                                                                            <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                                {obj.gst_treatment !== "Unregistered Business" ? (
                                                                                    <>
                                                                                        <div className="card-title flex-column">
                                                                                            <div className="fw-bolder mb-1">GST IN : {obj.GstIn}</div>
                                                                                        </div>
                                                                                        <div className="fs-6 fw-bold text-gray-700">{obj.legal_name}</div>
                                                                                        <div className="fw-semibold text-gray-400">Business Legal Name</div>
                                                                                        <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                                            <div className="fs-6 fw-bold text-gray-700">{obj.gst_treatment}</div>
                                                                                            <div className="fw-semibold text-gray-400">GST Treatment</div>
                                                                                        </div>
                                                                                        <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                                            <div className="fs-6 fw-bold text-gray-700">{obj.place_of_supply}</div>
                                                                                            <div className="fw-semibold text-gray-400">Place of Supply</div>
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <div className="fs-6 fw-bold text-gray-700">{obj.gst_treatment}</div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )
                                        }
                                    </>
                                    : navtype === "Contact" ?
                                        <>
                                            {
                                                vendorDetails != undefined && (
                                                    <div className="card-body p-9" style={{ overflow: "auto", maxHeight: "400px" }}>
                                                        {
                                                            vendorContactPersons.every(obj => !obj.salutation && !obj.firstName && !obj.lastName && !obj.email && !obj.workPhone && !obj.mobile && !obj.designation && !obj.department) ? (
                                                                <div
                                                                    className="empty-data-box"
                                                                    style={{ border: "1px solid #ddd", padding: "20px", borderRadius: "5px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", textAlign: "center", }}
                                                                >
                                                                    NO CONTACT ASSOCIATED.
                                                                </div>
                                                            ) : (
                                                                <div className="container" style={{ minWidth: "max-content" }}>
                                                                    {vendorContactPersons.map((obj, indx) => (
                                                                        <div
                                                                            key={indx}
                                                                            className="contact-box"
                                                                            style={{ border: "1px solid #ddd", padding: "10px", margin: "10px 0", borderRadius: "5px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", }}
                                                                        >
                                                                            <div>
                                                                                <strong>Name: </strong>
                                                                                {obj.salutation + " " + obj.firstName + " " + obj.lastName}
                                                                            </div>
                                                                            <div>
                                                                                <strong>Email: </strong>
                                                                                {obj.email}
                                                                            </div>
                                                                            <div>
                                                                                <strong>Work Phone: </strong>
                                                                                {obj.workPhone}
                                                                            </div>
                                                                            <div>
                                                                                <strong>Mobile: </strong>
                                                                                {obj.mobile}
                                                                            </div>
                                                                            <div>
                                                                                <strong>Designation: </strong>
                                                                                {obj.designation}
                                                                            </div>
                                                                            <div>
                                                                                <strong>Department: </strong>
                                                                                {obj.department}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                )}
                                        </>
                                        :
                                        navtype === "History" &&
                                            vendorAdditonalDetailsAPIState ? <div className="spinner-border text-primary"></div> :
                                            vendorDetails != undefined &&
                                            <div className="card-body p-9">
                                                {
                                                    vendorHistoryDetails.map((obj, index) => {
                                                        return (
                                                            <React.Fragment key={index}>
                                                                <div className="m-0">
                                                                    <div className="d-flex align-items-sm-center mb-5">
                                                                        <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                                                                            <div className="flex-grow-1 me-2">
                                                                                {obj.operation === "add" ? <span className="badge badge-lg badge-secondary fw-bold my-2">Created</span> : <span className="badge badge-lg badge-primary fw-bold my-2">Updated</span>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="timeline">
                                                                        <div className="timeline-item align-items-center mb-7">
                                                                            <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                                            <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0">
                                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                                                    <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                                                    <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                                                </svg>
                                                                            </span>
                                                                            <div className="timeline-content m-0">
                                                                                <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                                                <span className="fs-6 fw-bold text-gray-800">{moment(obj.log_date_time).format("lll")} </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="timeline-item align-items-center">
                                                                            <div className="timeline-line w-40px"></div>
                                                                            <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0">
                                                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                                                    <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                                                    <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                                                </svg>
                                                                            </span>
                                                                            <div className="timeline-content m-0">
                                                                                <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                                                <span className="fs-6 fw-bold text-gray-800">{obj.user_id}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {vendorHistoryDetails.length > 1 && <div className="separator separator-dashed my-6"></div>}
                                                            </React.Fragment>
                                                        )
                                                    })
                                                }
                                            </div>
                    }
                </div>
            </Drawer>
        </>
    );
}


export default ListVendor;